// Node.js `global` shim for browser — some npm packages (e.g. `immediate`,
// used by `autocomplete.js`) reference `global` which doesn't exist in browser
// context when bundled by esbuild.
// MUST be imported before any package that uses `global`.
if (typeof global === 'undefined') {
    window.global = window;
}
